import React from 'react';
import PageHeader from '../components/PageHeader';
import KanbanBoard from '../components/KanbanBoard';

export default function Tasks() {
  return (
    <div>
      <PageHeader
        overline="Workflow"
        title="Task Board"
        subtitle="Cross-module Kanban · drag cards to update status, link tasks to projects, POs, NCRs and more"
      />
      <KanbanBoard fullScreen />
    </div>
  );
}
